var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _linearGradient2, _linearGradient3, _clipPath, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarContact = function SvgAvatarContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70
  }, props), /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "avatar-contact_svg__g",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0f6"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "avatar-contact_svg__h",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0f6",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "avatar-contact_svg__i",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0f6",
    stopOpacity: 0.212
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar-contact_svg__b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3ee"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar-contact_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3ee"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar-contact_svg__d",
    x1: 0.361,
    y1: 0.842,
    y2: 0.536,
    xlinkHref: "#avatar-contact_svg__c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-contact_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(738 473)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-contact_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__b",
    d: "M58.223 849.985a5.716 5.716 0 0 1 3.5-4.9 4.72 4.72 0 0 1 5-4.162c.059 0 .117.015.176.021a4.708 4.708 0 0 1 5.644-3.006 6.378 6.378 0 0 1 12.068 3.538 4.724 4.724 0 0 1-.177 8.862 19.919 19.919 0 0 0-2.871-4.141 6.338 6.338 0 0 1-3.233.906c-.157 0-.314 0-.474-.007-1.219-.081-2.207-1.093-3.26-1.163s-1.744 1.737-3.11 1.646a1.967 1.967 0 0 0-1.954 1.6c-.19.718.177 2.111-.272 3.239a5.84 5.84 0 0 1-3.56 3.372 5.548 5.548 0 0 1-1.844.292 1.461 1.461 0 0 0-.3.055 2.934 2.934 0 0 0-1.506 2.391 2.675 2.675 0 0 1-1.479-3.538 5.718 5.718 0 0 1-2.348-5.005Z",
    transform: "translate(-58.21 -834.355)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-contact_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.035 869.933a2.934 2.934 0 0 1 1.506-2.391.168.168 0 0 0 .013-.075c.1.006.193.018.292.019a5.548 5.548 0 0 0 1.845-.292 5.84 5.84 0 0 0 3.552-3.365c.449-1.129.082-2.521.272-3.239a1.968 1.968 0 0 1 1.954-1.6c1.366.09 2.057-1.716 3.11-1.646s2.041 1.082 3.26 1.163c.16.011.317.008.474.007a6.338 6.338 0 0 0 3.233-.906 19.926 19.926 0 0 1 2.871 4.141c.092.175.183.351.27.53 3.6 7.383 2.224 15.458-3.067 18.037-5.62 2.738-13.962-4.7-14.112-4.629-1.611.785-3.805-.4-4.9-2.649a5.611 5.611 0 0 1-.573-3.105Z",
    transform: "translate(-60 -857.338)",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".avatar-contact_svg__b,.avatar-contact_svg__f{fill:#e0e0f6}.avatar-contact_svg__f,.avatar-contact_svg__j{isolation:isolate}.avatar-contact_svg__j{fill:#979cd6}.avatar-contact_svg__n,.avatar-contact_svg__o{fill:#b8b8e7}.avatar-contact_svg__n{opacity:.44}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-738 -473)",
    style: {
      clipPath: "url(#avatar-contact_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h75.545v75.545H0z",
    transform: "translate(735.228 467.455)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__f",
    d: "M787.752 527.453c1.006.518 2.03 1 3.069 1.455a2.42 2.42 0 0 0 2.087.013c1.435 1.972 2.935 5.319 4.408 10.5.45 1.581.836 3.222 1.181 4.9a10.258 10.258 0 0 1-1.092.35l-12.923 4.426c-.133-2.126-.211-8.353-.211-9.684 0-5.077 1.386-10.052 3.481-11.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.673 942.5c1.232-7.2 1.375-25.907-1.407-28.28-6.065-5.175-14.615-2.072-16.019-13.1-1-7.874-1.505-2.237-2.2 1.631-.989-2.637-3.469-11.064-4.67-1.631-1.4 11.028-10.119 7.925-16.184 13.1-2.782 2.373-2.853 9.275-1.62 16.476Z",
    transform: "translate(710.054 -386.034)",
    style: {
      fill: "url(#avatar-contact_svg__b)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.982 941.107a63.85 63.85 0 0 0-1.05 4.3 9.834 9.834 0 0 0 2.194.947l11.662 5.167c.133-2.127.239-9.083.239-10.414 0-11.247-6.778-22.024-13.045 0Z",
    transform: "translate(640.225 -401.69)",
    style: {
      fill: "url(#avatar-contact_svg__c)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.023 888.286a2.679 2.679 0 0 1 3.921-2.2 4.722 4.722 0 1 1-1.652 5.023 2.681 2.681 0 0 1-2.269-2.823Z",
    transform: "translate(675.738 -380.245)",
    style: {
      fill: "#979cd6"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__j",
    d: "M766.736 522.649c-.007-.1-.137-1.638-.139-1.739.624-.528 1.186-1.007 1.858-1.589 0 .133-.1 1.359-.094 1.484.206 2.891 9.956 5.263 8.909-.632a17.529 17.529 0 0 1-.245-2.1 8.4 8.4 0 0 0 1.238 1.925c.057.586.137 1.19.248 1.815 1.386 7.793-11.501 4.658-11.775.836Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__f",
    d: "M778.567 510.657s-2.335 3.622-1.289 9.517-8.7 3.523-8.909.632 2.51-7.8.754-12.62 9.444 2.471 9.444 2.471Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.077 896.457a12.226 12.226 0 0 0-.326-6.369c-1.756-4.824 9.444 2.472 9.444 2.472a13.538 13.538 0 0 0-1.477 8.077 9.7 9.7 0 0 1-7.641-4.18Z",
    transform: "translate(696.373 -381.903)",
    style: {
      fill: "url(#avatar-contact_svg__d)",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__f",
    d: "M760.24 503.462a2.934 2.934 0 0 1 1.506-2.391.168.168 0 0 0 .013-.075c.1.006.193.018.292.019a5.548 5.548 0 0 0 1.845-.292 5.84 5.84 0 0 0 3.552-3.365c.449-1.129.082-2.521.272-3.239a1.968 1.968 0 0 1 1.954-1.6c1.366.09 2.057-1.716 3.11-1.646s2.041 1.082 3.26 1.163c.16.011.317.008.474.007a6.338 6.338 0 0 0 3.233-.906 19.926 19.926 0 0 1 2.871 4.141c.092.175.183.351.27.53 3.6 7.383 2.224 15.458-3.067 18.037-5.62 2.738-13.962-4.7-14.112-4.629-1.611.785-3.805-.4-4.9-2.649a5.611 5.611 0 0 1-.573-3.105Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__j",
    d: "M756.415 494.917a5.716 5.716 0 0 1 3.5-4.9 4.72 4.72 0 0 1 5-4.162c.059 0 .117.015.176.021a4.708 4.708 0 0 1 5.644-3.006 6.378 6.378 0 0 1 12.068 3.538 4.724 4.724 0 0 1-.177 8.862 19.919 19.919 0 0 0-2.871-4.141 6.338 6.338 0 0 1-3.233.906c-.157 0-.314 0-.474-.007-1.219-.081-2.207-1.093-3.26-1.163s-1.744 1.737-3.11 1.646a1.967 1.967 0 0 0-1.954 1.6c-.19.718.177 2.111-.272 3.239a5.84 5.84 0 0 1-3.56 3.372 5.548 5.548 0 0 1-1.844.292 1.461 1.461 0 0 0-.3.055 2.934 2.934 0 0 0-1.506 2.391 2.675 2.675 0 0 1-1.479-3.538 5.718 5.718 0 0 1-2.348-5.005Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.64,
      clipPath: "url(#avatar-contact_svg__e)"
    },
    transform: "translate(756.402 479.287)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__b",
    d: "M1.086 17.71a12.7 12.7 0 0 0 .659 4.193 6.445 6.445 0 0 1 1.719-11.369 11.881 11.881 0 0 0-2.378 7.176ZM19.278 1.667a16.048 16.048 0 0 0-4.986 1.979A8.145 8.145 0 0 1 28.787 2.6a15.016 15.016 0 0 0-9.509-.933Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__b",
    d: "M4.764 8.775a7.339 7.339 0 0 0-1.455 1.976 3.725 3.725 0 0 1 5.37-3.917 6.869 6.869 0 0 0-3.915 1.941ZM10.264 4.991a7.344 7.344 0 0 0-1.456 1.976 3.726 3.726 0 0 1 5.371-3.917 6.869 6.869 0 0 0-3.915 1.941Z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__n",
    d: "M783.494 494.395a.218.218 0 0 0 .139-.049 4.825 4.825 0 0 0 1.216-3.639 3.684 3.684 0 0 0-1.5-3.012.221.221 0 1 0-.247.367 3.253 3.253 0 0 1 1.305 2.666 4.391 4.391 0 0 1-1.052 3.275.221.221 0 0 0 .139.393Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__o",
    d: "M782.393 486.331h.013a4.821 4.821 0 0 0 3.11-2.247 3.68 3.68 0 0 0 .538-3.321.221.221 0 1 0-.414.155 3.252 3.252 0 0 1-.494 2.925 4.392 4.392 0 0 1-2.765 2.047.221.221 0 0 0 .013.441Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__o",
    d: "M783.069 486.009a.223.223 0 0 0 .16-.068 3.092 3.092 0 0 0 .388-2.854 5.8 5.8 0 0 0-3.988-4.081.225.225 0 0 0-.276.147.221.221 0 0 0 .148.276 5.38 5.38 0 0 1 3.688 3.769 2.708 2.708 0 0 1-.28 2.435.221.221 0 0 0 .007.313.217.217 0 0 0 .153.063ZM758.759 490.186a.222.222 0 0 0 .215-.168 5.381 5.381 0 0 1 3.566-3.885 2.713 2.713 0 0 1 2.448.15.221.221 0 0 0 .288-.335 3.089 3.089 0 0 0-2.87-.235 5.8 5.8 0 0 0-3.861 4.2.221.221 0 0 0 .162.267.206.206 0 0 0 .052.006Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__n",
    d: "M767.713 513.656a4.473 4.473 0 0 0 1.177-.159.221.221 0 0 0 .156-.271.224.224 0 0 0-.271-.155 3.848 3.848 0 0 1-3.661-.881 1.905 1.905 0 0 1-.748-1.548.222.222 0 0 0-.434-.09 2.3 2.3 0 0 0 .879 1.96 4.21 4.21 0 0 0 2.902 1.144Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "avatar-contact_svg__o",
    d: "M762.983 511.134a.221.221 0 0 0 .011-.441 3.3 3.3 0 0 1-2.9-2.052.224.224 0 0 0-.287-.124.221.221 0 0 0-.124.287 3.74 3.74 0 0 0 3.291 2.33ZM765.131 486.36a.221.221 0 0 0 .22-.2 2.9 2.9 0 0 0-1.854-2.666.222.222 0 0 0-.193.4 2.476 2.476 0 0 1 1.607 2.232.22.22 0 0 0 .2.238ZM758.423 503.201a.221.221 0 0 0 .206-.3 2.477 2.477 0 0 1 .319-2.731.221.221 0 0 0-.3-.324 2.9 2.9 0 0 0-.43 3.219.221.221 0 0 0 .205.136Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#avatar-contact_svg__f)"
    },
    transform: "translate(760.204 490.867)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.519,
    cy: 11.519,
    r: 11.519,
    transform: "translate(-5.422 -7.826)",
    style: {
      fill: "url(#avatar-contact_svg__g)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.904,
    cy: 5.904,
    r: 5.904,
    transform: "translate(18.466 5.839)",
    style: {
      fill: "url(#avatar-contact_svg__h)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.904,
    cy: 5.904,
    r: 5.904,
    transform: "translate(5.138 9.941)",
    style: {
      fill: "url(#avatar-contact_svg__i)"
    }
  }))));
};
export default SvgAvatarContact;